import Slide from '@mui/material/Slide';
import { Mui } from '@osu/react-ui';
import { useDispatch, useSelector } from 'react-redux';
import { closeAlert, hideAlertBeforeClose, selectAlertState } from '../services/graphql/slices/global-alerts-slice';

const ALERT_CLOSE_REASONS = new Set(['timeout', 'escapeKeyDown'])

export const GlobalAlertHandler = () => {
  const dispatch = useDispatch()
  const alertState = useSelector(selectAlertState)
  const { currentAlert } = alertState

  const handleClose = () => { dispatch(hideAlertBeforeClose()) }

  if (currentAlert) return (
    <>
      <Mui.Snackbar
        key={`alert-${currentAlert.id}`}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={currentAlert.visible}
        onClose={(event, reason) => { if (ALERT_CLOSE_REASONS.has(reason)) { handleClose() } }}
        TransitionComponent={SlideTransition}
        TransitionProps={{ onExited: () => dispatch(closeAlert()) }}
      >
        <Mui.Alert
          onClose={() => handleClose()}
          role="alert"
          severity={currentAlert.severity}
          style={{ display: 'flex', alignItems: 'center', padding: '1rem', width: '50vw' }}
        >
          {currentAlert.message}
        </Mui.Alert>
      </Mui.Snackbar>
    </>
  );
};

function SlideTransition(props) { return <Slide {...props} direction="down" /> }

export default GlobalAlertHandler